// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3NPya","buttons":"styles_buttons__3IGN2"};